import { useEffect, useState } from "react";
import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import "./top-listing-headers.css";
import { sortOptionsAlphabeticallyOtherLast } from "../../../utils/helper";

interface ListingTopHeaderProps {
  PageHeading: string;
  ButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleSort: () => void;
  currentSortDirection: string;
  Count: number,
  handleSelectChange: any;
  filterOptions?: { title: string; count: number }[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  aggregateValuesFilters?: Record<string, number>;
}

export default function ChatListingTopHeader({
  PageHeading,
  ButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleSort,
  currentSortDirection,
  Count,
  handleSelectChange,
  activeTab,
  setActiveTab,
  filterOptions = [], // default fallback
  aggregateValuesFilters,
}: ListingTopHeaderProps) {
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [secondaryFilters, setSecondaryFilters] = useState<
    { title: string; count: number }[]
  >([]);

  useEffect(() => {
    if (aggregateValuesFilters) {
      const options = Object.entries(aggregateValuesFilters).map(
        ([title, count]) => ({ title, count })
      );

      const totalCount = options.reduce((acc, curr) => acc + curr.count, 0);
      setSecondaryFilters([
        { title: "All Messages", count: totalCount },
        ...sortOptionsAlphabeticallyOtherLast(options, (o) => o.title),
      ]);
    } else {
      setSecondaryFilters([]); // safe fallback
    }
  }, [aggregateValuesFilters]);

  return (
     <div className="top-listing-header chat-responsive-header">
      <div className="top-listing-header-top chat-responsive-header-top">
         <div className="chat-responsive-title-row">
           <H2 text={`${PageHeading || ""}${Count !== undefined ? ` (${Count})` : ""}`} />      
           {ButtonName && (
             <div className="chat-responsive-btn-mobile">
               <SimpleButton label={ButtonName} onClick={onClick} />
             </div>
           )}
         </div>
          <div className="search-sort-container chat-responsive-search-sort">      
          <div className="chat-responsive-search-input">
            <SearchFilterInput
              placeholder="Search Message"
              searchTerm={searchTerm}
              handleSearch={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="chat-responsive-select-wrapper">
            <select
              className={`select-filters form-select form-control chat-responsive-select ${isSelectOpen ? "open" : ""}`}
              onChange={(e) => handleSelectChange(e.target.value)}
              onMouseDown={() => setIsSelectOpen(!isSelectOpen)}
              onBlur={() => setIsSelectOpen(false)}
            >
              {secondaryFilters.map((option) => (
                <option key={option.title} value={option.title}>
                  {option.title}
                </option>
              ))}
            </select>
          </div>
          <div className="chat-responsive-btn-desktop">
          {ButtonName && <SimpleButton label={ButtonName} onClick={onClick} />}   
          </div>   
         </div>
      </div>
    </div>
  );
}
